/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  if (n === 1) return 1;
  return 5;
}

export default [
  'ka',
  [
    ['a', 'p'],
    ['AM', 'PM'],
  ],
  [['AM', 'PM'], , ['AM', 'შუადღ. შემდეგ']],
  [
    ['კ', 'ო', 'ს', 'ო', 'ხ', 'პ', 'შ'],
    ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
    [
      'კვირა', 'ორშაბათი', 'სამშაბათი',
      'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი',
      'შაბათი'
    ],
    ['კვ', 'ორ', 'სმ', 'ოთ', 'ხთ', 'პრ', 'შბ']
  ],
  ,
  [
    ['ი', 'თ', 'მ', 'ა', 'მ', 'ი', 'ი', 'ა', 'ს', 'ო', 'ნ', 'დ'],
    [
      'იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ',
      'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'
    ],
    [
      'იანვარი', 'თებერვალი', 'მარტი',
      'აპრილი', 'მაისი', 'ივნისი', 'ივლისი',
      'აგვისტო', 'სექტემბერი', 'ოქტომბერი',
      'ნოემბერი', 'დეკემბერი'
    ]
  ],
  ,
  [
    ['ძვ. წ.', 'ახ. წ.'], ,
    [
      'ძველი წელთაღრიცხვით',
      'ახალი წელთაღრიცხვით'
    ]
  ],
  1, [6, 0], ['dd.MM.yy', 'd MMM. y', 'd MMMM, y', 'EEEE, dd MMMM, y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1}, {0}',
    ,
    ,
  ],
  [
    ',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞',
    'არ არის რიცხვი', ':'
  ],
  ['#,##0.###', '#,##0%', '#,##0.00 ¤', '#E0'], '₾', 'ქართული ლარი',
  plural
];
